import { Stack } from '@mui/material';

import { ClickableText } from '@/components/shared/clickableText';

import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const TextDetailsTuple = ({
  primaryProp,
  onPrimaryClick,
  secondaryProp,
  onSecondaryClick,
  enableSameValue = false,
  sameColor = false,
  copyable = false,
}: {
  primaryProp?: string;
  onPrimaryClick?: () => void;
  secondaryProp?: string;
  onSecondaryClick?: () => void;
  enableSameValue?: boolean;
  sameColor?: boolean;
  copyable?: boolean;
}) => {
  return (
    <Stack
      sx={{
        gap: copyable ? undefined : '4px',
        overflow: 'hidden',
      }}
    >
      <PrimaryProp
        onClick={onPrimaryClick}
        primaryProp={primaryProp}
        copyable={copyable}
      />
      <SecondaryProp
        onClick={onSecondaryClick}
        secondaryProp={secondaryProp}
        primaryProp={primaryProp}
        enableSameValue={enableSameValue}
        sameColor={sameColor}
        copyable={copyable}
      />
    </Stack>
  );
};

const PrimaryProp = ({
  primaryProp,
  onClick,
  copyable,
}: {
  primaryProp?: string;
  onClick?: () => void;
  copyable: boolean;
}) => {
  if (!primaryProp) {
    return null;
  }

  return !copyable ? (
    <OverflowTooltip text={primaryProp} onClick={onClick} />
  ) : (
    <CopyToClipboardWrapper textToCopy={primaryProp}>
      <OverflowTooltip text={primaryProp} onClick={onClick} />
    </CopyToClipboardWrapper>
  );
};

const SecondaryProp = ({
  secondaryProp,
  primaryProp,
  onClick,
  enableSameValue,
  sameColor,
  copyable,
}: {
  secondaryProp?: string;
  primaryProp?: string;
  onClick?: () => void;
  enableSameValue?: boolean;
  sameColor?: boolean;
  copyable?: boolean;
}) => {
  if (!secondaryProp || (!enableSameValue && primaryProp === secondaryProp)) {
    return null;
  }

  const colorSx = {
    color:
      primaryProp && !sameColor
        ? 'var(--mui-palette-text-secondary) !important'
        : 'text.primary',
  };

  const content = (
    <OverflowTooltip
      text={secondaryProp}
      onClick={onClick}
      renderContent={(text, ref) => (
        <ClickableText
          ref={ref}
          variant={primaryProp ? 'body2' : 'subtitle1'}
          className='truncate'
          sx={colorSx}
          onClick={onClick}
        >
          {text}
        </ClickableText>
      )}
    />
  );

  if (!copyable) {
    return content;
  }

  return (
    <CopyToClipboardWrapper textToCopy={secondaryProp}>
      {content}
    </CopyToClipboardWrapper>
  );
};
